import algosdk from "algosdk";

// --- Tipos de Datos ---
export type NetworkType = "Mainnet" | "Testnet";

interface TokenConfig {
  id: number;
  name: string;
  decimals: number;
  image: string;
}

interface AppConfig {
  appId: number;
  applicationAddress: string;
}

interface NetworkConfig {
  nodeUrl: string;
  app: {
    marketplace: AppConfig;
    referidos: AppConfig;
    ruleta: AppConfig;
    stake: AppConfig;
    target: AppConfig;
  };
  tokens: {
    umq: TokenConfig;
    hlk: TokenConfig;
  };
}

const ALGORAND_CONFIG: Record<NetworkType, NetworkConfig> = {
  Mainnet: {
    nodeUrl: "https://mainnet-api.algonode.cloud",
    app: {
      marketplace: {
        appId: 3117877946,
        applicationAddress: "JORF5GRQ7FZTKIOU4WFTRZIOZL2LE3LFEAMYL7WAIO2BXLM3YYGUKTHCJE",
      },
      referidos: {
        appId: 3117723381,
        applicationAddress: "DHAYK7KCIMTMIETCXIJN3U5GWGJYYWQHUZR4TXGZNJWHVYGHMLVUIE3SNU",
      },
      ruleta: {
        appId: 3117888142,
        applicationAddress: "VD5BSGDMDOBSLBRHMSM4OXVQQJMENMZWPOTVRCPHFIXEZ6LNCSOAVAOVAE",
      },
      stake: {
        appId: 3117918266,
        applicationAddress: "WD4O625BAD6D2F7M5OQ5WYOTRFBBHMIRGTH634J2G4WSBTGRPRV2A3RUFM",
      },
      target: {
        appId: 3118225518,
        applicationAddress: "7GZ22FYPBKBYM4EEIERVTGMW4T5WIPPZLJZ3473UET7AUL55SMFANJZTMM",
      },
    },
    tokens: {
      umq: { id: 1810650610, name: "UMQ", decimals: 9, image: "/images/umq.avif" },
      hlk: { id: 1784249575, name: "HLK", decimals: 9, image: "/images/holkan.avif" },
    },
  },
  Testnet: {
    nodeUrl: "https://testnet-api.algonode.cloud",
    app: {
      marketplace: {
        appId: 748946547,
        applicationAddress: "HPBA7TGAK6YFVL7EXDSMR4PBTOOH26UIJGPY7UTI2ZMPGMGFFNIP7AA7UU",
      },
      referidos: {
        appId: 748945594,
        applicationAddress: "INKTRYEHA2HABN55AWJSXT3HJ5HYBGNQKV3MYEPMX6VO7BD47JZTZJL5RY",
      },
      ruleta: {
        appId: 0, // PENDIENTE
        applicationAddress: "PENDIENTE", 
      },
      stake: {
        appId: 748946206,
        applicationAddress: "MXCRNIJNKFIIIVDYJC3OGQSTH653BUWYRLOO3TRVE4YB6OBEZATNJQGUUQ",
      },
      target: {
        appId: 0, // PENDIENTE
        applicationAddress: "PENDIENTE", 
      },
    },
    tokens: {
      umq: { id: 748884896, name: "UMQ", decimals: 9, image: "/images/umq.avif" },
      hlk: { id: 748885409, name: "HLK", decimals: 9, image: "/images/holkan.avif" },
    },
  },
};


export const getNetworkConfig = (network: NetworkType) => {
    return ALGORAND_CONFIG[network];
};

export const getAlgodClient = (network: NetworkType) => {
    const config = getNetworkConfig(network);
    return new algosdk.Algodv2("", config.nodeUrl, "");
};


export const fetchBalances = async (
    address: string,
    network: NetworkType
): Promise<{ algo: number; umq: number; hlk: number }> => {
    const client = getAlgodClient(network);
    const config = getNetworkConfig(network);

    const ASA_UMQ = config.tokens.umq.id;
    const ASA_HLK = config.tokens.hlk.id;

    try {
        const info = await client.accountInformation(address).do();
        const algo = info.amount / 1e6;

        const umqAsset = info.assets?.find((a: any) => a["asset-id"] === ASA_UMQ);
        const hlkAsset = info.assets?.find((a: any) => a["asset-id"] === ASA_HLK);

        const umq = umqAsset ? umqAsset.amount / config.tokens.umq.decimals : 0; 
        const hlk = hlkAsset ? hlkAsset.amount / config.tokens.hlk.decimals : 0;

        return { algo, umq, hlk };
    } catch (err) {
        console.error("Error obteniendo balances:", err);
        return { algo: 0, umq: 0, hlk: 0 };
    }
};